// extracted by mini-css-extract-plugin
export default {"root":"SentEmailManagment_root__kE6b-"};